export const headCardHelp = {
  placeholder: 'Hi, I need assistance. Can you help me?'
}